import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import * as R from 'ramda'
import Checkbox from '../../../../form/Checkbox'
import Button from '../../../../../UniformComponents/Button'
import { getQuestionTitle, getOptionTitle } from '../../../../../utils/QuestionHelper'
import AXTab from '../../../../../Models/AdvancedXTab'
import XTab from './XTab'
import Accordion from '../../Accordion'
import ReportFilterModal from '../../Modal/Filter'
import SubmitModal from './SubmitModal'

import GrabIcon from '../../../../../assets/images/move-icon.svg'
import InfoAccordion from '../../../../InfoAccordion'
import Panel from '../../../../../UniformComponents/Panel'
import PanelHeader from '../../../../../UniformComponents/PanelHeader'
import Menu from '../../../../../UniformComponents/Menu'

import './advancedXTab.scss'
import Input from '../../../../form/Input'
import RuleGroup from '../../Modal/Filter/model/RuleGroup'

const SectionX = (props) => (
    <div style={{
        overflow: 'auto', flex: (props.flex || 1), padding: '10px 13px', display: 'flex', flexDirection: 'column', background: '#cbd0e2', borderRadius: '8px',
    }}
    >
        {props.children}
    </div>
)

const Question = ({ children }) => (
    <div
        style={{
            padding: '10px',
            borderRadius: '8px',
            background: '#e5e8f5',
            marginTop: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }}
    >
        {children}
    </div>
)

const DraggableQuestion = ({ children, provided }) => (
    <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        style={{
            padding: '10px',
            borderRadius: '8px',
            background: '#e5e8f5',
            marginTop: '5px',
            ...provided.draggableProps.style,
        }}
    >
        {children}
    </div>
)

const ListX = ({ children, provided = {} }) => (
    <div
        ref={provided.innerRef}
        {...provided.droppableProps}
        style={{
            flex: 1, overflow: 'auto', background: '#FFF', padding: '10px', borderRadius: '8px', marginTop: '10px',
        }}
    >
        {children}
    </div>
)

class AdvancedXTab extends Component {
    optionList = [
        'columnPct',
        // 'rowPct',
        'cellN',
        'totalColumnN',
        'totalRowN',
        'totalRowPct',
        'avg',
        'zScore',
        'tTest',
        'chiSquare',
    ]

    questionMap = {}

    filter = []

    constructor(props) {
        super(props)
        this.state = {
            collapseLeft: false,
        }
        this.initState()
    }

    initState = () => {
        const { store, reportStore } = this.props
        const { survey } = store

        this.filterQuestions = []
        const surveyQuestions = survey.pages.reduce((questions, page) => {
            if (page.pageType === 'ST') {
                const pageQuestions = []
                questions = questions.concat(page.questions.reduce((list, q) => {
                    const question = reportStore.questionMap.get(q.questionId)
                    const questionTitle = getQuestionTitle({
                        content: question.content.shortTitle,
                        locale: reportStore.locale,
                        defaultLocale: survey.metadata.defaultLocale,
                        initialLocale: question.metadata.initialLocale,
                    })
                    const label = R.pathOr(questionTitle, ['text'], questionTitle)
                    if (!['ST', 'TA', 'TX', 'UV', 'TL', 'I', 'OD', 'DT'].includes(question.questionTypeCode)) {
                        let options = []
                        if (['TB', 'RT'].includes(question.questionTypeCode)) {
                            const optionSetY = question.optionSetY.options.map((o) => ({
                                label: getOptionTitle({
                                    langs: o.langs,
                                    locale: reportStore.locale,
                                    defaultLocale: survey.metadata.defaultLocale,
                                    initialLocale: question.metadata.initialLocale,
                                }),
                                setYId: o.id,
                            }))
                            const optionSetX = question.optionSetX.options.map((o) => ({
                                label: getOptionTitle({
                                    langs: o.langs,
                                    locale: reportStore.locale,
                                    defaultLocale: survey.metadata.defaultLocale,
                                    initialLocale: question.metadata.initialLocale,
                                }),
                                setXId: o.id,
                            }))
                            options = optionSetY.reduce((list, optionY) => {
                                const a = list.concat(
                                    optionSetX.reduce((listX, optionX) => {
                                        listX.push({
                                            label: `${optionY.label} - ${optionX.label}`,
                                            setYId: optionY.setYId,
                                            setXId: optionX.setXId,
                                        })
                                        return listX
                                    }, []),
                                )
                                console.log(`a ${JSON.stringify(a, null, 4)}`)
                                return a
                            }, [])
                        } else if (['SG'].includes(question.questionTypeCode)) {
                            const yOptions = R.pathOr([], ['optionSetY', 'options'])(question).slice()
                                .concat(R.pathOr([], ['optionSetY', 'options'])(q).slice())
                            console.log('SG', JSON.stringify(yOptions))
                            const optionSetY = yOptions.map((o) => {
                                const langs = o.langs instanceof Map
                                    ? Array.from(o.langs).reduce((o, [k, v]) => {
                                        console.log('SG here', k, v)
                                        o[k] = v.text
                                        return o
                                    }, {})
                                    : o.langs
                                console.log('SG', JSON.stringify(langs), (o.langs instanceof Map))
                                console.log(`SG ${o.langs.get('en_GB').text} ${JSON.stringify(o.langs, null, 4)}`, reportStore.locale, question.metadata.initialLocale)
                                return {
                                    label: getOptionTitle({
                                        langs,
                                        locale: reportStore.locale,
                                        defaultLocale: survey.metadata.defaultLocale,
                                        initialLocale: question.metadata.initialLocale,
                                    }),
                                    setYId: o.id,
                                }
                            })
                            console.log(`SG ${JSON.stringify(optionSetY)}`)
                            const optionSetX = question.optionSetX.options.map((o) => ({
                                label: getOptionTitle({
                                    langs: o.langs,
                                    locale: reportStore.locale,
                                    defaultLocale: survey.metadata.defaultLocale,
                                    initialLocale: question.metadata.initialLocale,
                                }),
                                setXId: o.id,
                            }))
                            options = optionSetY.reduce((list, optionY) => {
                                const a = list.concat(
                                    optionSetX.reduce((listX, optionX) => {
                                        listX.push({
                                            label: `${optionY.label} - ${optionX.label}`,
                                            setYId: optionY.setYId,
                                            setXId: optionX.setXId,
                                        })
                                        return listX
                                    }, []),
                                )
                                console.log(`a ${JSON.stringify(a, null, 4)}`)
                                return a
                            }, [])
                        } else {
                            console.log(JSON.stringify(question, null, 4))
                            options = question.optionSet.options.map((o) => ({
                                label: getOptionTitle({
                                    langs: o.langs,
                                    locale: reportStore.locale,
                                    defaultLocale: survey.metadata.defaultLocale,
                                    initialLocale: question.metadata.initialLocale,
                                }),
                                setYId: o.id,
                            }))
                        }
                        pageQuestions.push({
                            label,
                            options,
                            id: q.questionId.toUpperCase(),
                        })
                    }
                    if (!['ST', 'TA', 'TX', 'TL', 'UV', 'I', 'OD', 'RT'].includes(question.questionTypeCode)) {
                        list.push({
                            value: q.questionId.toUpperCase(),
                            oid: question.metadata.oid,
                            label,
                        })
                        this.questionMap[q.questionId.toUpperCase()] = label
                    }
                    return list
                }, []))
                this.filterQuestions.push({
                    title: page.title,
                    questions: pageQuestions,
                })
            }
            return questions
        }, [])

        this.state = {
            dataLoading: false,
            questions: surveyQuestions.slice(),
            loading: true,
            reportResult: [],
            columns: [],
            rows: [],
            filters: {
                question: new RuleGroup(RuleGroup.getDefaultLogic('question')),
                campaign: new RuleGroup(RuleGroup.getDefaultLogic('campaign')),
                responseDate: new RuleGroup(RuleGroup.getDefaultLogic('responseDate')),
                openEnded: new RuleGroup(RuleGroup.getDefaultLogic('openEnded')),
            },
            name: 'Cross Tabbing',
            reportquestions: [],
            showFilters: false,
            submitModalStatus: false,
            menuActive: false,
            editName: false,
        }
    }

    componentDidMount() {
        this.loadXTab()
    }

    loadXTab = () => {
        const { questions } = this.state
        const { reportStore } = this.props
        const { currAdvancedXTab } = reportStore

        console.log('loadXTab', this.state.loading)
        console.log(`loadXTab ${JSON.stringify(currAdvancedXTab)}`)

        this.advancedXTab = new AXTab(R.pathOr({}, ['xtab'])(currAdvancedXTab))
        this.filter = this.advancedXTab.filter.slice()
        this.xTabId = R.pathOr(0, ['id'])(currAdvancedXTab)
        console.log(JSON.stringify(this.advancedXTab, null, 4))
        console.log(questions.map(({ value }) => value))

        this.setState({
            rows: questions.filter(({ value }) => this.advancedXTab.rows.includes(value)),
            columns: questions.filter(({ value }) => this.advancedXTab.columns.includes(value)),
            name: this.advancedXTab.name,
            options: this.advancedXTab.options,
            loading: false,
        })
    }

    onDragEnd = ({ source, destination }) => {
        if (!destination || destination.droppableId === 'questions') {
            return
        }

        console.log('onDragEnd', source, destination)
        console.log('onDragEnd', source.droppableId, destination.droppableId)

        const rows = this.state.rows.slice()
        const columns = this.state.columns.slice()
        const questions = this.state.questions.slice()

        if (destination.droppableId === 'columns') {
            const [question] = questions.splice(source.index, 1)
            if (columns.some(({ value }) => value === question.value)) {
                return
            }
            columns.push(question)
            console.log(destination.index, question)
            console.log(columns)
            this.advancedXTab.columns.push(question.value)
        } else if (destination.droppableId === 'rows') {
            const [question] = questions.splice(source.index, 1)
            if (rows.some(({ value }) => value === question.value)) {
                return
            }
            console.log('onDragEnd', question)
            rows.push(question)
            this.advancedXTab.rows.push(question.value)
        }

        this.setState({
            rows,
            columns,
            options: this.advancedXTab.options,
        })
    }

    addAll = () => {
        const rows = this.state.questions.slice()
        rows.forEach(({ value }) => {
            this.advancedXTab.rows.push(value)
        })

        this.setState({
            rows,
        })
    }

    removeRow = (index) => {
        const rows = this.state.rows.slice()
        const question = rows.splice(index, 1)
        this.advancedXTab.rows.splice(index, 1)
        this.setState({
            rows,
        })
    }

    removeColumn = (index) => {
        const columns = this.state.columns.slice()
        const question = columns.splice(index, 1)
        this.advancedXTab.columns.splice(index, 1)
        this.setState({
            columns,
        })
    }

    changeOption = (key, value) => {
        this.advancedXTab.options[key] = value //! this.advancedXTab.options[key]
        this.setState({
            options: Object.assign({}, this.advancedXTab.options),
        })
    }

    setName = ({ value }) => {
        this.advancedXTab.name = value
        this.setState({
            name: value,
        })
    }

    toggleFilter = () => {
        this.setState({
            showFilters: !this.state.showFilters,
        })
    }

    runReport = async () => {
        const { filters } = this.state
        const { store, reportStore } = this.props
        const { survey } = store
        console.log('runReport')
        const reportquestions = []
        this.setState({
            dataLoading: true,
        })
        const crossTabs = this.advancedXTab.rows.reduce((arrCrossTabs, rowId) => arrCrossTabs.concat(this.advancedXTab.columns.reduce((arr, columnId) => {
            reportquestions.push({
                rowId,
                columnId,
            })
            return arr.concat([{
                rowQuestion: rowId.toUpperCase(),
                columnQuestion: columnId.toUpperCase(),
            }])
        }, [])), [])
        const body = JSON.stringify({
            crossTabs,
            filters: process.env.NEW_CROSS_TAB_ENDPOINT
                ? {
                    ...filters,
                }
                : undefined,
            filter: process.env.NEW_CROSS_TAB_ENDPOINT
                ? undefined
                : [],
            locale: reportStore.locale,
        })
        const data = process.env.NEW_CROSS_TAB_ENDPOINT
            ? await store.http.post(`/report/v1/${survey.id}/advancedcrosstab`, body)
            : await store.http.post(`/v1/survey/${survey.id}/report/advancedcrosstab`, body)
        this.crossTabData = data
        const reportResult = R.groupBy(({ groupId }) => groupId)(data)

        console.log(reportResult)

        this.setState({
            dataLoading: false,
            reportResult,
            reportquestions,
        })
    }

    save = async () => {
        const { store, reportStore } = this.props
        const { survey, surveyToken } = store
        console.log(this.advancedXTab.rows)
        console.log(this.advancedXTab.columns)

        this.advancedXTab.filter = this.filter

        const json = {
            xtab: this.advancedXTab.toJSON(),
        }

        if (!this.advancedXTab.name) {
            store.addNotification(null, 'Provide name', 'error')
            return
        }

        if (R.pathOr(0, ['xTabId'])(this)) {
            try {
                const result = await store.http.put(
                    `/survey/${survey.id}/advancedxtab/${this.xTabId}`,
                    JSON.stringify(json),
                    surveyToken,
                )

                store.addNotification(null, result.msg, 'success')
                const xTabs = reportStore.xTabs
                    .slice()
                    .map((xtab) => {
                        const { id } = xtab
                        if (id === this.xTabId) {
                            return {
                                id: this.xTabId,
                                xtab: this.advancedXTab,
                            }
                        }
                        return xtab
                    })
                reportStore.xTabs = xTabs
                // if (typeof reportStore.advancedXTabOnSave === 'function') {
                //     reportStore.advancedXTabOnSave({
                //         id: this.xTabId,
                //         xtab: this.advancedXTab.toJSON(),
                //     })
                // }
            } catch (e) {
                store.addNotification(null, `Error: ${e}`, 'error')
            }
        } else {
            try {
                const result = await store.http.post(
                    `/survey/${survey.id}/advancedxtab`,
                    JSON.stringify(json),
                    surveyToken,
                )

                store.addNotification(null, result.msg, 'success')
                reportStore.xTabs.push({ id: result.id, xtab: this.advancedXTab })
                // reportStore.advancedXTabOnSave({
                //     id: result.id,
                //     xtab: this.advancedXTab.toJSON(),
                // })
            } catch (e) {
                store.addNotification(null, `Error: ${e}`, 'error')
            }
        }

        console.log(`save ${JSON.stringify()}`)
    }

    close = () => {
        const { reportStore } = this.props
        reportStore.currAdvancedXTab = undefined
        reportStore.showAdvancedXTab = false
    }

    addToFilter = (pageIndex, questionIndex, optionIndex) => {
        const option = this.filterQuestions[pageIndex].questions[questionIndex].options[optionIndex]

        console.log(`addToFilter ${option}`)

        this.filterQuestions[pageIndex].questions[questionIndex].options.splice(optionIndex, 1)
    }

    getQuestionTitle = (xtabs, groupId) => {
        const { questionMap } = this
        console.log(xtabs)
        const questions = this.filterQuestions.reduce((a, b) => a.concat(b.questions.slice()), [])

        let set1
        let optionLabel
        const { rowQuestion, columnQuestion } = xtabs
        const columnTitles = questionMap[columnQuestion]

        if (groupId && groupId.includes('_')) {
            set1 = groupId.split('_')[1]
            const question = questions.find(({ id }) => id === rowQuestion)
            if (question) {
                const option = question.options.find(({ setYId }) => setYId.toUpperCase() === set1)
                optionLabel = option ? option.label.split('-')[0].trim() : ''
            }
        }

        return `${questionMap[rowQuestion]}${optionLabel ? ` - ${optionLabel}` : ''} VS ${columnTitles}`
    }

    excelExport = () => {
        const { store } = this.props
        const options = Object.keys(this.state.options).reduce((obj, key) => {
            const v = this.state.options[key]
            console.log(key, v)
            if (['columnPct', 'cellN', 'rowPct', 'zScore'].includes(key) && v) {
                obj.cellOptions.push(key)
            } else if (['totalRowN', 'totalRowPct'].includes(key) && v) {
                obj.totalOptions.push(key)
            } else if (['avg', 'totalColumnN'].includes(key) && v) {
                obj.footerOptions.push(key)
            }
            return obj
        }, {
            cellOptions: [],
            totalOptions: [],
            footerOptions: [],
        })
        const data = {
            kind: 'AdvancedCrossTab',
            crossTabs: this.crossTabData.map((data) => {
                data.label = `${this.getQuestionTitle(data, data.groupId)} VS ${this.questionMap[data.columnQuestion]}`
                return data
            }),
            options,
        }

        const copyOfState = { ...this.state }

        if (R.isNil(this.crossTabData) || R.isEmpty(this.crossTabData)) {
            copyOfState.submitLoading = false
            copyOfState.submitModalStatus = true
            this.res = 'No data to download'
            this.submitStatus = 500
            this.setState(copyOfState)
            return
        }

        copyOfState.submitLoading = true
        copyOfState.submitModalStatus = true
        this.setState(copyOfState)

        console.log(JSON.stringify(options, null, 4))
        store.http.post(
            '/export/excel',
            JSON.stringify(data),
            store.token,
        )
            .then((res) => {
                this.res = res
                this.submitStatus = 200
                copyOfState.submitModalStatus = true
                copyOfState.submitLoading = false
                this.setState(copyOfState)
                console.log('res: ', res)
            })
            .catch((err) => {
                console.log('err: ', err)
                this.res = err.message
                this.submitStatus = err.status
                copyOfState.submitModalStatus = true
                copyOfState.submitLoading = false
                this.setState(copyOfState)
            })

        // this.setState({
        //     submitModalStatus: true,
        // })
    }

    handleSubmitModal = () => {
        this.setState({
            submitModalStatus: false,
        })
    }

    saveFilter = (filter) => {
        this.filter = filter
    }

    closeFilter = () => {
        this.setState({
            showFilters: false,
        })
    }

    getMenu = () => (
        [
            <div
                className="option-line"
                onClick={(e) => {
                    e.stopPropagation()
                    this.setState({
                        editName: true,
                    })
                }}
            >
                <i className="fa-light fa-edit" />
                Rename
            </div>,
            <div className="option-line">
                <i className="fa-light fa-file-export" />
                Export
            </div>,
            <div className="option-line error">
                <i className="fa-light fa-circle-xmark" />
                Delete
            </div>,
        ]
    )

    setMenuActive = () => {
        console.log('setMenuActive', !this.state.menuActive)
        this.setState({
            menuActive: !this.state.menuActive,
        })
    }

    saveFilter = (filterKey, ruleGroup) => {
        this.setState({
            showFilters: false,
            filters: {
                ...this.state.filters,
                [filterKey]: ruleGroup,
            },
        })

        console.log(this.state.filters)
    }

    renderName = () => {
        const { editName, name } = this.state

        if (!editName) return <h2>{name}</h2>

        return (
            <Input defaultValue={name} onBlur={this.setName} />
        )
    }

    renderQuestion = ({ value, oid, label }, index, remove) => (
        <div className="question" key={value}>
            <div className={`oidCode oid${oid}`} />
            <img src={GrabIcon} />
            <div style={{
                display: 'flex', alignItems: 'center', flex: 1, paddingRight: '5px', justifyContent: 'space-between',
            }}
            >
                {label}
                <i
                    className="fa-regular fa-circle-xmark"
                    style={{ float: 'right', cursor: 'pointer' }}
                    onClick={() => remove(index)}
                />
            </div>
        </div>
    )

    toggleCollapse = () => {
        const { collapseLeft } = this.state
        this.setState({ collapseLeft: !collapseLeft })
    }

    render() {
        const { reportStore } = this.props
        const { filters, showFilters, collapseLeft } = this.state

        return (
            <div id="crossTab">
                <Panel cssClass="crossTab-panel">
                    <PanelHeader>
                        <div>
                            {this.renderName()}
                            <div>
                                <Button
                                    label={i18n.t('report_export_options')}
                                    icon="fa-light fa-download"
                                    cssClass="regular tertiary"
                                    onClick={this.excelExport}
                                />
                                <Button
                                    label={i18n.t('crossTab.goBack')}
                                    icon="fa-light fa-file-export"
                                    cssClass="regular tertiary"
                                    onClick={this.close}
                                />
                                {process.env.NEW_CROSS_TAB_ENDPOINT && (
                                    <Button
                                        label={i18n.t('report_filters_add')}
                                        icon="fa-light fa-circle-plus"
                                        cssClass="regular tertiary"
                                        onClick={() => this.setState({ showFilters: true })}
                                    />
                                )}
                            </div>
                        </div>
                    </PanelHeader>
                    <div className="panelBody">
                        <Panel
                            style={{
                                padding: '24px 24px',
                                display: 'flex',
                                gap: '24px',
                                position: 'relative',
                            }}
                            cssClass={collapseLeft ? 'collapse collapsable' : 'collapsable'}
                        >
                            <ReportFilterModal
                                reportStore={reportStore}
                                filters={filters}
                                show={showFilters}
                                onSave={this.saveFilter}
                                onClose={() => { this.setState({ showFilters: false }) }}
                            />
                            <div className="iconContainer" onClick={this.toggleCollapse}>
                                {
                                    collapseLeft
                                        ? <i className="fa-regular fa-chevron-right" />
                                        : <i className="fa-regular fa-chevron-left" />
                                }
                                <div
                                    className="collapsedMenuLabel"
                                    style={{ display: collapseLeft ? 'block' : 'none' }}
                                >
                                    {i18n.t('crossTab.collapseLabel')}
                                </div>
                            </div>
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <div style={{
                                    display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, gap: '16px',
                                }}
                                >
                                    <div style={{
                                        display: 'flex', flexDirection: 'column', gap: '16px', minHeight: '50%', maxHeight: '50%', height: '100%',
                                    }}
                                    >
                                        <h5>{i18n.t('questions')}</h5>
                                        <Droppable droppableId="questions">
                                            {(provided) => (
                                                <div
                                                    id=""
                                                    className="questionList scrollable"
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                >
                                                    {this.state.questions.map((q, index) => (
                                                        <Draggable
                                                            key={q.value}
                                                            draggableId={q.value}
                                                            id={q.value}
                                                            index={index}
                                                        >
                                                            {(provided) => (
                                                                <Fragment>
                                                                    <div
                                                                        className="question"
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                    >
                                                                        <div className={`oidCode oid${q.oid}`} />
                                                                        <img src={GrabIcon} />
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            {q.label}
                                                                        </div>
                                                                    </div>
                                                                </Fragment>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                </div>
                                            )}
                                        </Droppable>
                                    </div>
                                    {!this.state.dataLoading && (
                                        <div style={{
                                            display: 'flex', flexDirection: 'column', minHeight: '50%', maxHeight: '50%', height: '100%', gap: '16px',
                                        }}
                                        >
                                            <label>{i18n.t('options')}</label>
                                            <fieldset className="scrollable" style={{ flexGrow: '1' }}>
                                                {this.optionList.map((key) => (
                                                    <Checkbox
                                                        name={key}
                                                        defaultChecked={R.pathOr(false, ['advancedXTab', 'options', key], this)}
                                                        label={i18n.t(`report.advanced_xtab.${key}`)}
                                                        onBlur={({ value }) => this.changeOption(key, value)}
                                                    />
                                                ))}
                                            </fieldset>
                                        </div>
                                    )}
                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'column', gap: '16px', flex: 1,
                                }}
                                >
                                    <div style={{
                                        display: 'flex', flexDirection: 'column', gap: '16px', minHeight: '0', height: '100%',
                                    }}
                                    >
                                        <div style={{
                                            display: 'flex', flexDirection: 'column', gap: '16px', minHeight: '50%', maxHeight: '50%', height: '100%',
                                        }}
                                        >
                                            <h5>
                                                {i18n.t('columns')}
                                            </h5>
                                            <Droppable droppableId="columns">
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                        className="questionList dropTarget scrollable"
                                                    >
                                                        {this.state.columns.map((q, i) => (
                                                            this.renderQuestion(q, i, this.removeColumn)
                                                        ))}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </div>
                                        <div style={{
                                            display: 'flex', flexDirection: 'column', gap: '16px', maxHeight: 'calc(50% - 58px)', height: '100%',
                                        }}
                                        >
                                            <h5>
                                                {i18n.t('rows')}
                                            </h5>
                                            <Droppable droppableId="rows">
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                        className="questionList dropTarget scrollable"
                                                    >
                                                        {this.state.rows.map((q, i) => (
                                                            this.renderQuestion(q, i, this.removeRow)
                                                        ))}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </div>
                                        <Button
                                            label={i18n.t('crossTab.runCrossTab')}
                                            onClick={this.runReport}
                                            icon="fa-light fa-chart-line-up"
                                            cssClass="regular secondary"
                                            style={{ justifyContent: 'center' }}
                                        />
                                    </div>
                                </div>
                            </DragDropContext>
                        </Panel>
                        <div className="dataPanel">
                            <Panel style={{ flex: 1, minWidth: 0 }}>
                                {this.state.reportResult.length === 0 && (
                                    <div
                                        className="noDataPlaceholder"
                                    >
                                        <img style={{ width: '450px', marginBottom: '40px' }} src={`${process.env.CDN_URL}/images/noDashboards.svg`} />
                                        <div className="title">{i18n.t('crossTab.emptyMsg')}</div>
                                    </div>
                                )}
                                {(!this.state.loading) && (
                                    <XTab dataLoading={this.state.dataLoading} reportquestions={this.state.reportquestions} questionMap={this.questionMap} questions={this.filterQuestions.reduce((a, b) => a.concat(b.questions.slice()), [])} reportResult={this.state.reportResult} options={this.state.options} />
                                )}
                            </Panel>
                        </div>
                    </div>
                </Panel>
                <SubmitModal
                    handleSubmitModal={this.handleSubmitModal}
                    modalStatus={this.state.submitModalStatus}
                    response={this.res}
                    loading={this.state.submitLoading}
                    status={this.submitStatus}
                />
            </div>
        )
    }
}

export default AdvancedXTab
